import { string, type } from 'io-ts'

export const TFileUploadResult = type({
  fileKey: string,
  originalName: string,
})
